var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery, useQueryClient, } from '@tanstack/react-query';
import { useAuthProvider, useLucidSdk } from '#context';
import { isPendingMember } from '#services';
import { DEFAULT_QUERY_RETRY } from '../../constants';
import { FilespacesKeyFactory } from '../../query-key-factories';
import { canFetchWorkspaceData } from '../../services';
import { useGetWorkspaceLoginStatus } from './useGetWorkspaceLoginStatus';
import { useWorkspaceById } from './useWorkspaceById';
export const filespaceListByWorkspaceIdQueryFactory = ({ lucidSdk, queryClient, workspaceId, }) => ({
    queryKey: FilespacesKeyFactory.byWorkspace(workspaceId),
    queryFn: async () => {
        const result = await lucidSdk
            .workspaceClient(workspaceId)
            .listFilespaces();
        // Updating cached data for each separate Filespace
        result.forEach((filespace) => {
            queryClient.setQueryData(FilespacesKeyFactory.exact(workspaceId, filespace.id), filespace);
        });
        return result;
    },
    networkMode: 'always',
});
// The filespaces list will also be updated upon an update in each of the Filespaces in it
// via the useFilespaceById.ts hook
export function useFilespaceListByWorkspaceId(workspaceId, { enabled = true, retry = DEFAULT_QUERY_RETRY, } = {}) {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const { currentUser } = useAuthProvider();
    const queryClient = useQueryClient();
    const { query: { data: workspaceLoginStatus }, } = useGetWorkspaceLoginStatus(workspaceId);
    const { query: { data: workspaceData }, } = useWorkspaceById(workspaceId);
    const query = useQuery({
        ...filespaceListByWorkspaceIdQueryFactory({
            lucidSdk,
            workspaceId,
            queryClient,
        }),
        enabled: canFetchWorkspaceData(workspaceLoginStatus) &&
            !isPendingMember(workspaceData, currentUser) &&
            enabled,
        retry,
    });
    return { query };
}
_react_refresh_temp_1(useFilespaceListByWorkspaceId, "O3xL1JPcoWp0VQxtyBkv9MvgYZc=", false, () => [useLucidSdk, useAuthProvider, useQueryClient, useGetWorkspaceLoginStatus, useWorkspaceById, useQuery]);
